import React, { type FC } from 'react'
import { PathwayStatus, usePathway } from '../../hooks/usePathway'
import { Badge, Button, Icon } from '@awell-health/design-system'
import { navigate } from '@reach/router'

export const PathwayNavigationBar: FC<{
  id: string
}> = ({ id }) => {
  const { pathway, loading } = usePathway(id)

  if (loading) return null

  const patientName = pathway?.patient?.profile?.name === '' ? 'Anonymous' : (pathway?.patient?.profile?.name ?? '')

  return (
    <div className="flex items-center gap-3">
      <Button
        shape="squareLg"
        variant="ghost"
        size={null}
        onClick={() => navigate(`/patients/${pathway?.patient?.id ?? ''}/pathways`)}
      >
        <Icon icon="RiArrowLeftDoubleFill" size={24} />
      </Button>
      <div className="flex items-center gap-1">
        <div
          className="text-lg font-medium text-slate-600 hover:underline hover:text-blue-700 cursor-pointer"
          onClick={() => navigate(`/patients/${pathway?.patient?.id ?? ''}/pathways`)}
        >
          {patientName}
        </div>
        <Icon icon="RiArrowRightSLine" size={24} />
        <div className="text-lg font-medium text-slate-600">{pathway?.title ?? ''}</div>
      </div>
      <div className="flex items-center gap-2">
        {pathway?.version && <Badge size={null} variant="success">{`Version ${pathway?.version}`}</Badge>}
        {pathway?.status === PathwayStatus.Stopped && (
          <Badge size={null} variant="error">
            Stopped
          </Badge>
        )}
      </div>
    </div>
  )
}

PathwayNavigationBar.displayName = 'PathwayNavigationBar'
